import React from 'react';
import {
  Box,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import RouteIcon from '@mui/icons-material/Route';
import ReplayIcon from '@mui/icons-material/Replay';

const ReportsMenu = ({ selectedSection, onSectionChange }) => {
  const reportsItems = [
    { id: 'route', icon: <RouteIcon />, label: 'Ruta' },
    { id: 'routeReplay', icon: <ReplayIcon />, label: 'Repetición Ruta' },
  ];

  return (
    <Box sx={{ overflow: 'auto', flex: 1 }}>
      <List sx={{ py: 0 }}>
        {reportsItems.map((item) => (
          <ListItemButton
            key={item.id}
            selected={selectedSection === item.id}
            onClick={() => onSectionChange(item.id)}
            sx={{
              py: 1.5,
              px: 2,
              '&.Mui-selected': {
                bgcolor: '#e3f2fd',
                borderLeft: '3px solid #1976d2',
                '&:hover': {
                  bgcolor: '#e3f2fd',
                },
              },
              '&:hover': {
                bgcolor: '#f5f5f5',
              },
            }}
          >
            <ListItemIcon
              sx={{
                minWidth: 40,
                color: selectedSection === item.id ? '#1976d2' : '#666',
              }}
            >
              {item.icon}
            </ListItemIcon>
            <ListItemText
              primary={item.label}
              primaryTypographyProps={{
                fontSize: '0.875rem',
                fontWeight: selectedSection === item.id ? 600 : 500,
                color: selectedSection === item.id ? '#1976d2' : '#333',
              }}
            />
          </ListItemButton>
        ))}
      </List>
    </Box>
  );
};

export default ReportsMenu;